import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { AuthGuard } from '../../auth.guard';

/**
 * MESC Services
 */
import {
  BaseService,
  UserService,
  ModuleService,
  UserProfileService,
  UserLastLoginDateService,
  RoleService,
} from './mesc.service';

/**
 * MESC Components
 */
import { MESCComponent } from './mesc.component';
import { MescAdministrationComponent } from './administration/administration.component';
import { UserOnboardingComponent } from './user-onboarding/user-onboarding.component';

export const mescRoutes = {
  path: 'MESC',
  component: MESCComponent,
  data: { breadcrumb: "MESC" },
  children: [
    {
      path: 'Administration',
      component: MescAdministrationComponent,
      canActivate: [AuthGuard],
      data: { breadcrumb: "Administration" },
    },
  ]
}


@NgModule({
  imports: [
    SharedModule,
  ],
  declarations: [
    MESCComponent,
    MescAdministrationComponent,
    UserOnboardingComponent,
  ],
  providers: [
    BaseService,
    UserService,
    ModuleService,
    UserProfileService,
    UserLastLoginDateService,
    RoleService
  ]
})
export class MescModule { }
